import { useState, useCallback } from "react";
import {
  putRecoverNoteURL,
  getDeletedNotesURL,
} from "../../utils/ConstantsURL";
import { toastAlert } from "../../utils/AlertContext";

export const useRecoverNotes = (token, id_documento, fecha) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const normalizeNotes = useCallback((data) => {
    return data.map((item) => ({
      id: item.id_sintesis,
      title: item.titulo || "Sin título",
      content: item.sintesis || "Sin contenido",
      deletedAt: item.fecha,
      testigos: [item.testigo] || "Sin medio",
    }));
  }, []);

  const getDeletedNotes = useCallback( async () => {
    try {
      setLoading(true);
      const response = await fetch(getDeletedNotesURL(id_documento, fecha), {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok)
        throw new Error(`HTTP error! status: ${response.status}`);

      const rawData = await response.json();
      const normalizedData = normalizeNotes(rawData);
      return normalizedData;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [token, id_documento, fecha, normalizeNotes]);

  const putRecoverNote = useCallback( async (id_sintesis) => {
    try {
      setLoading(true);

      const response = await fetch(putRecoverNoteURL(), {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ id_sintesis }),
      });

      if (!response.ok)
        throw new Error(`HTTP error! status: ${response.status}`);

      const result = await response.json();
      toastAlert("Nota restaurada correctamente", "success");
      return result;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  },[token]);

  return {
    getDeletedNotes,
    putRecoverNote,
    loading,
    error,
  };
};
